import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostListAppointmentPage } from '@/services/wms/appointment';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt,
    PopupDatePickerCpt
  },
  data() {
    return {
      searchForm: {
        chnName: '',
        isRelatedTrade: 'yes',
        statusList: ['03']
      },
      curType: 'raiseStartDate',
      btnLoading: false,
      listRequest: rqtPostListAppointmentPage,
      codeResItems: [{
        title: '预约单状态',
        dataIndex: 'status',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'status'
      }]
    };
  },
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {
    onSearch() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onSelectDateClick(type) {
      this.curType = type;
      this.$refs['PopupDateTimeCpt'].showView();
    },
    onDateTimeSelectedChange(val) {
      this.searchForm[this.curType] = val;
    },
    onSubmit() {
      this.btnLoading = true;
      this.$refs['ListViewCpt'].initListData();
    },
    onListDataChange() {
      if (this.btnLoading) {
        this.btnLoading = false;
      }
    },
    getStatusStyle(status) {
      let color = undefined;
      switch (status) {
        case '01':
          color = '#ed6a0c';
          break;
        case '02':
          color = '#07c160';
          break;
        case '03':
          color = '#1989fa';
          break;
        case '04':
          color = '#ff976a';
          break;
        case '05':
          color = '#ee0a24';
          break;
      }
      return color;
    }
  }
};